module.exports = __webpack_public_path__ + "static/media/trash-undo-alt.1d639e39.svg";